module.exports = __webpack_public_path__ + "static/media/surface-2.fcfc65a4.png";